import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  className?: string;
}

const CTASection = ({ className = '' }: CTASectionProps) => {
  return (
    <section className={`py-20 lg:py-28 bg-primary text-primary-foreground ${className}`}>
      <div className="mx-auto px-6 lg:px-12 max-w-4xl text-center">
        <div className="mb-8">
          <Icon
            name="BuildingOffice2Icon"
            size={48}
            variant="outline"
            className="mx-auto mb-6"
          />
          <h2 className="font-headline font-bold text-3xl lg:text-4xl mb-6">
            Ready for Infrastructure-First Advertising?
          </h2>
          <p className="font-body text-lg opacity-90 leading-relaxed max-w-2xl mx-auto">
            If you're a professional advertiser or agency seeking reliable infrastructure without the overhead of full-service relationships, let's discuss how Danny Clans Media can support your operations.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            href="/contact"
            className="px-8 py-4 bg-accent text-accent-foreground font-headline font-semibold text-base rounded-sm hover:bg-accent/90 transition-colors duration-300 shadow-institutional inline-flex items-center space-x-2"
          >
            <span>Professional Inquiry</span>
            <Icon name="ArrowRightIcon" size={20} variant="outline" />
          </Link>
          <Link
            href="/services"
            className="px-8 py-4 bg-transparent border-2 border-primary-foreground text-primary-foreground font-headline font-semibold text-base rounded-sm hover:bg-primary-foreground hover:text-primary transition-colors duration-300 inline-flex items-center space-x-2"
          >
            <span>Review Services</span>
            <Icon name="DocumentTextIcon" size={20} variant="outline" />
          </Link>
        </div>

        <div className="pt-8 border-t border-primary-foreground/20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            <div className="flex items-start space-x-3">
              <Icon
                name="ClockIcon"
                size={24}
                variant="outline"
                className="flex-shrink-0 mt-1"
              />
              <div>
                <p className="font-headline font-semibold text-sm mb-1">
                  Response Time
                </p>
                <p className="font-body text-sm opacity-80">
                  Professional inquiries answered within 24 business hours
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Icon
                name="DocumentCheckIcon"
                size={24}
                variant="outline"
                className="flex-shrink-0 mt-1"
              />
              <div>
                <p className="font-headline font-semibold text-sm mb-1">
                  Qualification Process
                </p>
                <p className="font-body text-sm opacity-80">
                  Brief technical discussion to ensure service fit
                </p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <Icon
                name="ShieldCheckIcon"
                size={24}
                variant="outline"
                className="flex-shrink-0 mt-1"
              />
              <div>
                <p className="font-headline font-semibold text-sm mb-1">
                  Confidentiality
                </p>
                <p className="font-body text-sm opacity-80">
                  All inquiries handled with institutional discretion
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;